import React, { Component } from 'react';
import classnames from 'classnames';
import {Col, Row} from 'react-bootstrap';
import Redux from 'redux';
import _ from 'underscore';


class CommunityUserSocialCheckBoxView extends Component {

    createMenuItem(link, icon, text) {
        if (link && !this.isSafeLink(link)) {
            return null;
        }
        var iconToDisplay = 'icon icon-' + icon + ' detail-icon';
        var item = classnames('detail-item-container color-1-border links text-left', {
            'hide': !link
        });
        return <div className={item} key={link + text}>
            <a className="link-item-container" href={link} target="_blank">
                <span className="make-relative">
                    <i className={iconToDisplay}/>
                </span>
                <span className="padding-left-small one-liner">{text}</span>
            </a></div>;
    }

    createTableItems(link, icon, text) {
        if (link && !this.isSafeLink(link)) {
            return null;
        }
        var iconToDisplay = 'icon icon-' + icon + ' social-section-box-icons color-1';
        var item = classnames('no-color', {
            'hide': !link
        });
        return <td key={link + text} className={item}>
            <a href={link} target="_blank">
                <i className={iconToDisplay}/>
                <div className="no-color social-link-text uppercase">{text}</div>
            </a>
        </td>;
    }

    createMenuItems(user) {
        if (!user) {
            return null;
        }
        var linkedinUrl = user && user.linkedinInfo && user.linkedinInfo.linkedinUrl;
        var website = user.web;
        var blog = user.blog;
        var company = user.company;
        var fullName = _.compact([user.firstName, user.lastName]).join(' ');
        var urlQuery = fullName && 'http://www.google.com/search?q=' + encodeURIComponent(fullName);
        var companyQuery = company && 'http://www.google.com/search?q=' + encodeURIComponent(company);
        return [
            this.createMenuItem(linkedinUrl, 'linkedin', 'Linkedin Profile'),
            this.createMenuItem(website, 'minisite', 'Website'),
            this.createMenuItem(blog, 'knowladge_center', 'Blog'),
            this.createMenuItem(urlQuery, 'search', 'SEARCH THE WEB: ' + fullName),
            this.createMenuItem(companyQuery, 'search', 'SEARCH THE WEB: ' + company)
        ];
    }

    // A case-sensitive `includes('javascript:')` substring check is not a
    // filter: `JavaScript:alert(1)` and `java&#9;script:` both pass it, and
    // React 18 renders `href="javascript:..."` verbatim. `new URL()` parsing
    // strips tabs/newlines and normalises the scheme to lowercase per the
    // WHATWG URL spec, so both bypasses land on the same rejected
    // `javascript:` protocol. `link` and `blog` are attendee-supplied and
    // legitimately off-origin, so this allowlists the schemes a profile link
    // should ever need rather than checking same-origin.
    isSafeLink = (link) => {
        try {
            const url = new URL(link, 'https://placeholder.invalid');
            return ['http:', 'https:', 'mailto:'].includes(url.protocol);
        } catch (e) {
            return false;
        }
    };

    createSocialBoxHtml(user) {
        if (!user) {
            return null;
        }
        var linkedinUrl = user && user.linkedinInfo && user.linkedinInfo.linkedinUrl;
        var fullName = _.compact([user.firstName, user.lastName]).join(' ');
        var urlQuery = fullName && 'http://www.google.com/search?q=' + encodeURIComponent(fullName);
        var companyQuery = user.company && 'http://www.google.com/search?q=' + encodeURIComponent(user.company);
        return [
            this.createTableItems(linkedinUrl, 'linkedin', 'LinkedIn profile'),
            this.createTableItems(user.web, 'minisite', 'Website'),
            this.createTableItems(user.blog, 'knowladge_center', 'Blog'),
            this.createTableItems(urlQuery, 'search', 'search the web: ' + fullName),
            this.createTableItems(companyQuery, 'search', 'search the web: ' + user.company)
        ];
    }

    render() {
        var user = this.props && this.props.user;
        return <div className="community-user-social-container">
            <div className="table-wrapper hidden-xs">
                <table className="community-user-social-box-wrapper">
                    <tbody>
                        <tr>
                            {this.createSocialBoxHtml(user)}
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="visible-xs">
                {this.createMenuItems(user)}
            </div>
        </div>;
    }
}

export default CommunityUserSocialCheckBoxView;
